import React from 'react';

import { flagStyles } from '../settings';

const SvgJP = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2688px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgJP;
